import React from "react";
import axios from "axios";
import { Spinner, SpinnerSize } from "@fluentui/react";
import Api from "../../services/Api";
import SingleTask from "../ManageCenter/SingleTask";
import SingleQARTask from "../ManageCenter/SingleQARTask";
import { QarTaskStatus } from "../../GlobalConst/globalEnums";
//import QARTask from "../ManageCenter/QARTask";

class SiteTasks extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: {
        qars: false,
        changes: false,
        sites: false,
      },
      qarTasks: [],
      changeTasks: [],
      approveTask: null,
    };
  }

  componentDidMount() {
    this.axiosCancelSource = axios.CancelToken.source();

    this.downloadData();
  }

  componentWillUnmount() {
    this.axiosCancelSource.cancel();
  }

  downloadData() {
    this.getQARTasks(this.props.site.id);
    this.getChangeTasks(this.props.site.id);
    this.getApproveTask(this.props.site.id);
  }

  getQARTasks(siteId) {
    this.setState((prevState) => ({
      isLoading: {
        qars: true,
      },
    }));

    Api.get(`/QARTasks?siteId=${siteId}`, {
      cancelToken: this.axiosCancelSource.token,
    })
      .then((res) => res.data)
      .then((qarTasksAll) => {
        var qarTasksFiltered = qarTasksAll.filter(
          (q) =>
            q.status === QarTaskStatus.Pending ||
            q.status === QarTaskStatus.Expired
        );
        this.setState((prevState) => ({
          isLoading: {
            qars: false,
          },
          qarTasks: qarTasksFiltered,
        }));
      })
      .catch((error) => {
        console.log(error);
      });
  }

  getChangeTasks(siteId) {
    this.setState((prevState) => ({
      isLoading: {
        changes: true,
      },
    }));

    Api.get(`/ApproverTasks?siteId=${siteId}&approval=1`, {
      cancelToken: this.axiosCancelSource.token,
    })
      .then((res) => res.data)
      .then((tasks) => {
        this.setState((prevState) => ({
          isLoading: {
            changes: false,
          },
          changeTasks: tasks,
        }));
      })
      .catch((error) => {
        console.log(error);
      });
  }

  getApproveTask(siteId) {
    this.setState((prevState) => ({
      isLoading: {
        sites: true,
      },
    }));

    Api.get(`/Site?id=${siteId}`, {
      cancelToken: this.axiosCancelSource.token,
    })
      .then((res) => res.data)
      .then((site) => {
        this.setState((prevState) => ({
          isLoading: {
            sites: false,
          },
          approveTask: site,
        }));
      })
      .catch((error) => {
        console.log(error);
      });
  }

  combineTasks() {
    let tasks = [];

    const approveTask = {
      ...this.state.approveTask,
      label: "createTask",
    };

    const changes = this.state.changeTasks.map((x) => {
      return {
        ...x,
        label: "changeTask",
      };
    });

    changes.map((x) => tasks.push(x));
    if (approveTask.siteStatus === "Pending Approval") {
      tasks.push(approveTask);
    }

    let result = tasks.sort(
      (a, b) =>
        new Date(b.created || b.requestDate) -
        new Date(a.created || a.requestDate)
    );

    return result;
  }

  refresh() {
    this.downloadData();
  }

  render() {
    const styles = {
      taskDivStyle: {
        flex: "1",
        width: "50%",
        display: "flex",
        justifyContent: "center",
      },
    };

    const myQARTasks = this.state.qarTasks.map((s) => (
      <div style={styles.taskDivStyle} key={s.id}>
        <SingleQARTask
          key={s.id}
          element={s}
          refresh={this.refresh.bind(this)}
        />
      </div>
    ));

    const myTasks = this.combineTasks().map((x) => (
      <div style={styles.taskDivStyle} key={x.id + x.label}>
        <SingleTask
          key={x.id + x.label}
          element={x}
          refresh={this.refresh.bind(this)}
        />
      </div>
    ));

    const allTasks = [...myQARTasks, ...myTasks];
    const spinner = (
      <Spinner style={{ margin: "200px" }} size={SpinnerSize.large} />
    );

    return (
      <div
        style={{
          padding: "20px 20px 20px 20px",
          maxWidth: "680px",
          minWidth: "380px",
        }}>
        <div style={{ display: "flex", flexWrap: "wrap", marginLeft: "20px" }}>
          {this.state.isLoading.qars || this.state.isLoading.changes
            ? spinner
            : allTasks}
        </div>
      </div>
    );
  }
}

export default SiteTasks;



// WEBPACK FOOTER //
// ./src/components/EditSite/SiteTasks.js